module.exports = __webpack_public_path__ + "img/073614.da0a8c15.png";